import React from 'react';
import './ConfirmDialog.css';

const ConfirmDialog = ({ 
  message, 
  onConfirm, 
  onCancel, 
  confirmText = 'Confirm', 
  cancelText = 'Cancel', 
  type = 'warning' 
}) => {
  return (
    <div className="confirm-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <div className={`confirm-header confirm-header-${type}`}>
          Confirm Action
        </div>
        <div className="confirm-body">
          <p className="confirm-message">{message}</p>
        </div>
        <div className="confirm-footer">
          <button onClick={onCancel} className="confirm-btn-cancel">
            {cancelText}
          </button>
          <button onClick={onConfirm} className={`confirm-btn-confirm confirm-btn-${type}`}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;